<template>
    <section>
        <div class="container">
            <MarqueeNews />
            <Banner/>
            <div class="live-sports">
                <div class="row g-2">
                    <div class="col-md-6">
                        <div class="sportDiv ic_section">
                            <router-link to="/inplay">
                                <img  rel="preload"   src="@/assets/images/banner-sport1.webp" class="img-fluid">
                                <p>{{ $t('sport','sports')}}</p>
                            </router-link>
                            <div class="sportText">
                                <p class="live_icon">
                                    <span></span>{{ $t('live','LIVE')}}
                                </p>
                                <div class="scroll-manu">
                                    <div class="side-menu" v-for="(count, sportName) in matchCounts" :key="sportName">
                                        <router-link to="/inplay">
                                            <h3>{{ sportName }}</h3>
                                            <span id="count">{{ count }}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="checkEventManageforSingleType('sports-book')">
                        <div class="sportDiv ic_section">
                            <a href="Javascript:void(0);" @click="goToSportsBook()">
                                <img  rel="preload"  src="@/assets/images/sportbook.webp" class="img-fluid">
                                <p>{{ $t('sportsbook','sports book')}}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="multi-game" v-if="sectionWiseGamesList[2].gamesList && sectionWiseGamesList[2].gamesList.length != 0">
                <div class="row g-2">
                    <div class="col-md-3 col-6" v-for="(item, gameIndex) in sectionWiseGamesList[2].gamesList"
                        :key="gameIndex">
                        <div class="sportDiv">
                            <router-link :to="{name: 'Games', params: {type: 'casino'}, query: {menuName: item.slug}}">
                                <img  rel="preload"  class="img-fluid" :src="item.imgSrc" @error="setDefaultImg($event)">
                                <p>{{ item.game_name }}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="multi-game" v-if="sectionWiseGamesList[0].gamesList && sectionWiseGamesList[0].gamesList.length!=0">
                <div class="row g-2">
                    <div class="col-md-3 col-6" v-for="(item, gameIndex) in sectionWiseGamesList[0].gamesList" :key="gameIndex">
                        <div class="sportDiv">
                            <a href="Javascript:void(0);" @click="loadGame(item)">
                                <img  rel="preload"  class="img-fluid" :src="item.image" @error="setDefaultImg($event)">
                                <p>{{ item.game_name }}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ae-casino">
                <div class="row g-2">
                    <div class="col-md-6">
                        <div class="sportDiv ic_section">
                            <router-link :to="{name: 'Games', params: { type: 'evolution' }}">
                                <img  rel="preload"  src="@/assets/images/intcasino.webp" class="img-fluid w-100">
                                <p>{{ $t('evolution','Evolution')}}</p>
                            </router-link>
                        </div>
                    </div>
                    <template v-if="sectionWiseGamesList[1].gamesList && sectionWiseGamesList[1].gamesList.length!=0">
                        <div class="col-md-3 col-6" v-for="(item, gameIndex) in sectionWiseGamesList[1].gamesList" :key="gameIndex">
                            <div class="sportDiv">
                                <router-link :to="{name: 'Games', params: {type: 'casino'}, query: {providerId: item.provider_id}}">
                                    <img  rel="preload"  class="img-fluid" :src="item.image" @error="setDefaultImg($event)">                                
                                    <p>{{ item?.provider }}</p>
                                </router-link>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="policy">
                <div class="row g-2">
                    <div class="col-12 col-md-12">
                        <div class="power-wrap">
                            <h3>
                                <img  rel="preload"  src="@/assets/images/gc.webp" class="img-fluid"  alt="Image description"> 
                            </h3>
                            <div class="licence_embed">
                                <img  rel="preload"  src="@/assets/images/lice.webp" class="img-fluid">
                            </div>
                            <p>
                                {{$siteSettings?.data?.domain_name}} {{ $t("laserbook-home-footer-info", "is the trading name of Sports Target B.V., a company incorporated and regulated in Curaçao under company number 148053 with it's registered office at Fransche Bloemweg 4, Willemstad, Curaçao.") }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="app-downlode">
                <div class="row g-2">
                    <div class="col-12">
                        <div class="foot">
                            <a href="#install-apk-model" data-bs-toggle="modal">
                                <img  rel="preload"  src="@/assets/images/btn-appdl.webp" class="download-app">
                            </a>` `
                        </div>
                    </div>
                    <ul class="social-icon-wrapper" v-if="$siteSettings?.data && $siteSettings?.data?.social_link">
                        <li v-if="$siteSettings?.data?.social_link.telegram_link">
                            <a :href="$siteSettings?.data?.social_link.telegram_link" target="_blank">
                                <img  rel="preload"  src="@/assets/images/telegram.png" class="telegram">
                            </a>
                        </li>
                        <li v-if="$siteSettings?.data?.social_link.instagram_link">
                            <a :href="$siteSettings?.data?.social_link.instagram_link" target="_blank">
                                <img  rel="preload"  src="@/assets/images/instagram.png" class="instagram">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <DownloadApkModal></DownloadApkModal>
</template>
<script>
import loadCasinoGame from '@/shared/services/casinoGamesHandler';
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { checkInEventMangeForSection,checkEventManageforSports,checkEventManageforSingleType} from '@/shared/services/eventLocks.js';
export default {
    name: 'Home',
    components: {
		Banner: defineAsyncComponent(() =>
			import('@/shared/components/banner/Banner.vue')
		),
        DownloadApkModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/DownloadApkModal.vue')
		),
        MarqueeNews: defineAsyncComponent(() =>
			import('@/shared/components/marquee-news/MarqueeNews.vue')
		),
    },
    data() {
        return {
            sectionsList: null,
            openIframeModal: false,
            sectionWiseGamesList: [
                {
                    slugName: 'top-games',
                    gamesList: null,
                },
                {
                    slugName: 'home-casino',
                    gamesList: null,
                },
                {
                    slugName: 'static-games',
                    gamesList: [
                        {
                            game_name: 'Aviator',
                            slug: 'aviator',
                            imgSrc: require('@/assets/images/aviator.gif')
                        },
                        {
                            game_name: 'Mines',
                            slug: 'mines',
                            imgSrc: require('@/assets/images/mines.gif')
                        },
                        {
                            game_name: 'Fun Games',
                            slug: 'fun-games',
                            imgSrc: require('@/assets/images/fungames.gif')
                        },
                        {
                            game_name: 'Color Pridiction',
                            slug: 'colour-game',
                            imgSrc: require('@/assets/images/color-pridiction.gif')
                        }
                    ],
                }
            ],
            loading: false,
            matchCounts: null,
            defImg: require('@/assets/images/default-casino-img.png')
        }
    },
    computed: {
        ...mapGetters(['gamesData','eventManage']),
    },
    mounted() {
        this.getCasinoGamesServiceCall();
        this.getInplayMatchCounts();
    },
    methods: {
        checkEventManageforSingleType,
        getInplayMatchCounts() {
            this.$apiCall('get', 'INPLAY_MATCHES_COUNT', null, 'sports').then(response => {
                if (response && response.status == 200) {
                    let respData = response.data.data;
                    let sportCount = {
                        cricket: 0,
                        football: 0,
                        tennis: 0,
                    };

                    for (const key  in  respData) {
                        if(checkEventManageforSports(key)) {
                            if(key == 4){
                                sportCount.cricket = respData[key].inplay
                            } else if (key == 1) {
                                sportCount.football = respData[key].inplay
                            } else if (key == 2) {
                                sportCount.tennis = respData[key].inplay
                            } else {
                                const sportName = respData[key].sport_name;
                                sportCount[sportName] = respData[key].inplay;
                            }
                        }
                    }
                    for (const key  in  sportCount) {
                        if(sportCount[key] == 0) {
                            delete sportCount[key];
                        }
                    }
                    this.matchCounts = sportCount;
                }
            }).catch(error => {
                if (error) {
                    // console.log("Error : ", error);
                }
            });
        },
        getCasinoGamesServiceCall() {                            
            let gamesData = this.gamesData;
            if (this.$auth.status) {
                checkInEventMangeForSection(gamesData)
                this.$store.dispatch('setGamesData', gamesData);
            };
            this.sectionsList = this.gamesData?.sections;                      
            this.setSectionList();
        },
        setSectionList() {
            try {
                for (let i = 0; i < this.sectionsList.length; i++) {
                    let gamesList = [];
                    if (this.sectionsList[i].menus) {
                        for (let j = 0; j < this.sectionsList[i].menus.length; j++) {
                            gamesList = gamesList.concat(this.sectionsList[i]?.menus[j]?.games);
                        }
                    } else {
                        gamesList = this.sectionsList[i].games;
                    }

                    let gameListNew = [];
                    
                    gameListNew = gamesList;
                    const naturalCollator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                    gameListNew.sort((a, b) => naturalCollator.compare(a.porder, b.porder));
                    switch (this.sectionsList[i].slug) {
                        case 'top-games':
                            this.sectionWiseGamesList[0].gamesList = gameListNew;
                            break;
                        case 'home-casino':
                            this.sectionWiseGamesList[1].gamesList = gameListNew;
                            break;
                    }
                }

            } catch (error) {
                
            }
        },
        loadGame(game) {
            if(!this.$auth.status) {
                this.$helper.showLogin();
                return;
            }
            loadCasinoGame.loadGame(game, this.$auth.user);
        },
        goToSportsBook() {
            if(this.$auth.status) {
                this.$router.push({ name: 'sports-book'})
            } else {
                this.$helper.showLogin()
                this.$errorToast('Please Login to view sportsbook');
            }
        },
        setDefaultImg(event) {
            event.target.src = this.defImg;
        }
    }
}
</script>

<style scoped>
.scroll-manu{
    padding-bottom: 20px !important;
    padding-left: 5px;
    padding-right: 5px;
}
</style>